import { AssessmentSessionProcessTypeId } from "../../../services/exams/assessmentSession/assessments.types";
import { AcceptanceStatus, SampleAssessmentSortBy } from "../../SampleAssessment/SampleAssessment.types";


export const getSortByPropertyNameFromColumnId = (columId: SampleAssessmentSortBy) => {
  switch (columId) {
    case 'examiner':
      return 'ExaminerLastName';
    case 'tasksSolutionSheetId':
      return 'RgzId';
    case 'examTaskGroupSolutionScoreId':
      return 'ExamTaskGroupSolutionScoreId';
    case 'schoolId':
      return 'SchoolId';
    case 'processType':
      return 'ProcessType';
    case 'pointSum':
      return 'PointSum';
    case 'progress':
      return 'Progress';
    case 'acceptanceStatus':
      return 'AcceptanceStatus';
    case 'updateDate':
      return 'UpdateDate';
    default:
      return '';
  }
};

export const Alerts = [
  {
    id: 'isCommentOnCriteria',
    label: 'Komentarz do kryterium'
  },
  {
    id: 'isCommentOnImage',
    label: 'Komentarz na stronie'
  },
  {
    id: 'isCommentOffPage',
    label: 'Komentarz poza stroną'
  },
  {
    id: 'isScoringAdjusted',
    label: 'Dostosowane zasady oceniania'
  },
]

export const Proceses = [
  {
    id: AssessmentSessionProcessTypeId.Training.toString(),
    label: 'Ćwiczeniowy'
  },
  {
    id: AssessmentSessionProcessTypeId.Qualification.toString(),
    label: 'Kwalifikacyjny'
  },
  {
    id: AssessmentSessionProcessTypeId.Control.toString(),
    label: 'Kontrolny'
  },
]

export const Progress = [
  {
    id: '0',
    label: '0-20%'
  },
  {
    id: '1',
    label: '20%-40%'
  },
  {
    id: '2',
    label: '40%-60%'
  },
  {
    id: '3',
    label: '60%-80%'
  },
  {
    id: '4',
    label: '80%-100%'
  },
]

export const AcceptanceStatuses = [
  {
    id: AcceptanceStatus.PzwoAccepted.toString(),
    label: 'Zaakceptowane przez PZWO'
  },
  {
    id: AcceptanceStatus.KkAccepted.toString(),
    label: 'Zaakceptowane przez KK'
  },
  {
    id: AcceptanceStatus.CzwoAssessed.toString(),
    label: 'Odesłane przez CZWO'
  },
]